module.exports = {
  familyName: 'Noto Sans JP',
  capHeight: 733,
  ascent: 1160,
  descent: -288,
  lineGap: 0,
  unitsPerEm: 1000
};